import React, { useRef } from "react";
import emailjs from "emailjs-com";

export const ContactForm = () => {
  const form = useRef();
  const myServiceKey = process.env.REACT_APP_SERVICE_ID;
  const myTemplateId = process.env.REACT_APP_TEMPLATE_ID;
  const myPublicKey = process.env.REACT_APP_PUBLIC_KEY;
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(myServiceKey, myTemplateId, form.current, myPublicKey)
      .then(
        (result) => {
          alert(
            "Message Sent successfully, thanks for your feedback :)",
            result.text
          );
        },
        (error) => {
          alert("An error occured, Plese try again", error.text);
        }
      );
    e.target.reset();
  };
  return (
    <div className="padding-contact-form" data-aos="fade-up">
      <form ref={form} onSubmit={sendEmail} className="contact-form">
        <div className="form-input-name-email">
          <div>
            <div className="label">
              <label htmlFor="name">Name</label>
            </div>
            <input
              type="text"
              name="name"
              placeholder="your name"
              className="input-name-sec"
              required
              autoComplete="off"
            />
          </div>
          <div>
            <div className="label">
              <label htmlFor="email">Email</label>
            </div>
            <input
              type="email"
              name="email"
              placeholder="your@email.com"
              className="input-email-sec"
              required
              autoComplete="off"
            />
          </div>
        </div>
        <div>
          <div className="label">
            <label htmlFor="message">Your Message</label>
          </div>
        </div>
        <textarea
          name="message"
          rows="6"
          placeholder="write your message here..."
          className="text-area-con"
          required
          autoComplete="off"
        />
        <div className="contact-message-submit-div">
          <button type="submit" className="message-type-submit-contact">
            Send
          </button>
        </div>
      </form>
    </div>
  );
};
